var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"KeyMetrics mt-3"},[_c('h4',{staticClass:"pb-3"},[_vm._v(" Key Metrics ")]),_c('table',{staticClass:"table table-sm"},_vm._l((_vm.tableData),function(row,index){return _c('tr',{key:`keyMetric_${index}`},[_c('th',{attrs:{"scope":"row"}},[_vm._v(" "+_vm._s(row.label)+" ")]),_c('td',[_vm._v(_vm._s(row.value))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }